module.exports = __webpack_public_path__ + "static/2012-boats-b70441b21c4c67d3afe8c98434553f99.jpg";